module.exports = __webpack_public_path__ + "8fe0bd1d3e62c597a0c46a61a89cbb87.ttf";